import { ICategory } from "api/interfaces/category-api.type";
import axios from "fetch-api/fetch-api";
import { IVehicle } from "interfaces/session/IVehicle";

export interface RecommendationItem {
  description: string;
  img_link: string;
  page_link: string;
  sku?: string;
  wasPrice?: number;
  price?: number;
}

export interface RecommendationSkuStatus {
  sku: string;
  complete_with_exists: boolean;
}
export interface RecommendationGroup<TItem = RecommendationItem> {
  rank: number;
  key: string;
  title: string;
  subtitle?: string;
  icon?: string;
  items: TItem[];
}

export interface RecommendationsResponse<TItem = RecommendationItem> {
  page_type: string;
  recommendation_groups: RecommendationGroup<TItem>[];
  cart_products?: RecommendationSkuStatus[];
  wishlist_products?: RecommendationSkuStatus[];
}
export interface RecommendationProductContext {
  url: string;
  category: ICategory;
  vehicle?: IVehicle;
  sku: string;
  product_tag?: string;
  description?: string;
}

export interface RecommendationsPayload {
  page_type: string;
  is_logged_in: boolean;
  fsa: string;
  event_type?: string;
  vehicles?: IVehicle[];
  locale: string;
  product?: RecommendationProductContext;
  cart_products?: RecommendationProductContext[];
  wishlist_products?: RecommendationProductContext[];
}

let cachedPayloadKey: string | null = null;
let cachedResponse: Promise<{ data: RecommendationsResponse<any> }> | null = null;

export default function getRecommendationsApi<TItem = RecommendationItem>(payload: RecommendationsPayload) {
  const payloadKey = JSON.stringify(payload);

  if (cachedPayloadKey === payloadKey && cachedResponse) {
    return cachedResponse;
  }

  cachedPayloadKey = payloadKey;
  cachedResponse = axios.post<RecommendationsResponse<TItem>>(
    "/p-products/recommendations",
    payload,
  );

  cachedResponse.catch(() => {
    cachedPayloadKey = null;
    cachedResponse = null;
  });

  return cachedResponse as Promise<{ data: RecommendationsResponse<TItem> }>;
}
